module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_null@3x.6166dc3b.png";